import axiosapi from "../../config/axiosConfig";
import {
  OBTENER_CLIENTE_HABILITADO_EXITO,
  OBTENER_CLIENTE_HABILITADO_ERROR,
  OBTENER_PRODUCTOS_EXITO,
  OBTENER_PRODUCTOS_ERROR,
  CREAR_PRODUCTO,
  ACTUALIZAR_PRODUCTO,
  SET_ERROR,
  SET_LOADING,
  OBTENER_CATEGORIAS_EXITO,
  OBTENER_CATEGORIAS_ERROR,
  OBTENER_PROVEEDORES_EXITO,
  OBTENER_PROVEEDORES_ERROR,
  SET_USER_EMAIL,
  SET_AUTH_TOKEN,
  OBTENER_USUARIO_EXITO,
  OBTENER_USUARIO_ERROR,
  OBTENER_CLIENTE_EXITO,
  OBTENER_CLIENTE_ERROR,
  OBTENER_USUARIOS_EXITO,
  OBTENER_USUARIOS_ERROR,
  CREAR_INGRESO_SUCCESS,
  CREAR_INGRESO_ERROR,
  CREAR_PROVEEDOR_EXITO,
  CREAR_PROVEEDOR_ERROR,
  CREAR_CATEGORIA_EXITO,
  CREAR_CATEGORIA_ERROR,
  REGISTRAR_SALIDA_REQUEST,
  REGISTRAR_SALIDA_SUCCESS,
  REGISTRAR_SALIDA_FAILURE,
  GET_REPORTE_SALIDAS,
  CREAR_PRESTAMO_EXITOSO,
  OBTENER_OBRAS,
  CREAR_OBRA,
  ACTUALIZAR_OBRA,
  OBRAS_ERROR,
  CREAR_PRESTAMO_ERROR,
  OBTENER_PRODUCTOS_SALIDAS_EXITO,
  OBTENER_PRODUCTOS_SALIDAS_ERROR,
  OBTENER_PRODUCTOS_PRESTAMOS_EXITO,
  OBTENER_PRODUCTOS_PRESTAMOS_ERROR,
  OBTENIENDO_PRESTAMOS_EXITO,
  OBTENIENDO_PRESTAMOS_ERROR,
  GET_REPORTE_INGRESOS,
  OBTENER_AUTORIZADOS_EXITO,
  OBTENER_AUTORIZADOS_ERROR,
  CREAR_AUTORIZADO_EXITO,
  CREAR_AUTORIZADO_ERROR,
  ACTUALIZAR_AUTORIZADO_EXITO,
  ACTUALIZAR_AUTORIZADO_ERROR,
  OBTENER_PRESTAMOS_ACTIVOS,
  DEVOLVER_PRESTAMO,
  FETCH_AUTORIZADOS_REQUEST,
  FETCH_AUTORIZADOS_SUCCESS,
  FETCH_AUTORIZADOS_FAILURE,
  ELIMINAR_PRODUCTO,
} from "../types";

export const eliminarProducto = (id) => async (dispatch) => {
  try {
    await axiosapi.delete(`/api/productos/${id}`);
    dispatch({ type: ELIMINAR_PRODUCTO, payload: id });
  } catch (error) {
    const mensaje = error.response?.data?.mensaje
    throw new Error(mensaje);
  }
};

export const obtenerPrestamosActivos = () => async (dispatch) => {
  try {
    const response = await axiosapi.get("/api/prestamosActi");
    dispatch({
      type: OBTENER_PRESTAMOS_ACTIVOS,
      payload: response.data,
    });
  } catch (error) {
    console.error("Error al obtener préstamos activos:", error);
  }
};
// Acción para obtener los autorizados por dni de cliente
export const fetchAutorizados = (clienteId) => async (dispatch) => {
  dispatch({ type: FETCH_AUTORIZADOS_REQUEST });

  try {
    const response = await axiosapi.get(`/api/autorizados/${clienteId}`);
    dispatch({
      type: FETCH_AUTORIZADOS_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_AUTORIZADOS_FAILURE,
      payload: error.message,
    });
  }
};

// Obtener autorizados
export const obtenerAutorizados = () => async (dispatch) => {
  try {
    const response = await axiosapi.get("/api/autorizados");
    dispatch({
      type: OBTENER_AUTORIZADOS_EXITO,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: OBTENER_AUTORIZADOS_ERROR,
      payload: error.response?.data?.mensaje || error.message,
    });
  }
};
// Acción para devolver un préstamo
export const devolverPrestamo = (id) => async (dispatch) => {
  try {
    const response = await axiosapi.put(`/api/devolucion?id=${id}`);
    dispatch({
      type: DEVOLVER_PRESTAMO,
      payload: id,
    });
    return response.data;
  } catch (error) {
    console.error("Error al devolver préstamo:", error);
    throw error;
  }
};

// Acción crearAutorizado
export const crearAutorizado = (autorizado) => async (dispatch) => {
  try {
    const response = await axiosapi.post("/api/autorizados", autorizado);
    dispatch({
      type: "CREAR_AUTORIZADO",
      payload: response.data,
    });
    return response.data;
  } catch (error) {
    console.error("Error al crear autorizado:", error);
    return null;
  }
};

// Actualizar un autorizado
export const actualizarAutorizado =
  (id, autorizadoData) => async (dispatch) => {
    try {
      const response = await axiosapi.put(
        `/api/autorizados/${id}`,
        autorizadoData
      );
      dispatch({
        type: ACTUALIZAR_AUTORIZADO_EXITO,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: ACTUALIZAR_AUTORIZADO_ERROR,
        payload: error.response?.data?.mensaje || error.message,
      });
    }
  };

// Acción para obtener productos
export const obtenerProductos = () => async (dispatch) => {
  try {
    const response = await axiosapi.get("/api/getproductos");
    dispatch({
      type: OBTENER_PRODUCTOS_EXITO,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: OBTENER_PRODUCTOS_ERROR,
      payload: error.response?.data?.mensaje || error.message,
    });
  }
};
export const obtenerProductosSalidas = () => async (dispatch) => {
  try {
    const response = await axiosapi.get("/api/getProductosSalidas");
    dispatch({
      type: OBTENER_PRODUCTOS_SALIDAS_EXITO,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: OBTENER_PRODUCTOS_SALIDAS_ERROR,
      payload: error.response?.data?.mensaje || error.message,
    });
  }
};

// Acción para obtener todas las obras
export const obtenerObras = () => async (dispatch) => {
  try {
    const response = await axiosapi.get("/api/obras");
    dispatch({
      type: OBTENER_OBRAS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: OBRAS_ERROR,
      payload: error.response?.data || "Error al obtener las obras",
    });
  }
};

// Acción para crear una nueva obra
export const crearObra = (nombre) => async (dispatch) => {
  try {
    const response = await axiosapi.post("/api/crearobra", { nombre });
    dispatch({
      type: CREAR_OBRA,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: OBRAS_ERROR,
      payload: error.response?.data || "Error al crear la obra",
    });
  }
};

// Acción para actualizar una obra
export const actualizarObra = (id, nombre) => async (dispatch) => {
  try {
    const response = await axiosapi.put(`/api/actualizarobra/${id}`, { nombre });
    dispatch({
      type: ACTUALIZAR_OBRA,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: OBRAS_ERROR,
      payload: error.response?.data || "Error al actualizar la obra",
    });
  }
};

export const obtenerProductosPrestamos = () => async (dispatch) => {
  try {
    const response = await axiosapi.get("/api/getProductosPrestamos");
    dispatch({
      type: OBTENER_PRODUCTOS_PRESTAMOS_EXITO,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: OBTENER_PRODUCTOS_PRESTAMOS_ERROR,
      payload: error.response?.data?.mensaje || error.message,
    });
  }
};

export const getReporteSalidas = () => async (dispatch) => {
  try {
    const { data } = await axiosapi.get("/api/salidas/reporte");
    dispatch({ type: GET_REPORTE_SALIDAS, payload: data });
  } catch (error) {
    console.error("Error al obtener el reporte de salidas:", error.message);
  }
};
export const getReporteIngresos = () => async (dispatch) => {
  try {
    const { data } = await axiosapi.get("/api/ingreso/reporte");
    dispatch({ type: GET_REPORTE_INGRESOS, payload: data });
  } catch (error) {
    console.error("Error al obtener el reporte de salidas:", error.message);
  }
};

export const obtenerPrestamos = () => async (dispatch) => {
  try {
    const { data } = await axiosapi.get("/api/prestamos/reporte");
    dispatch({
      type: OBTENIENDO_PRESTAMOS_EXITO,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: OBTENIENDO_PRESTAMOS_ERROR,
      payload: error.message,
    });
  }
};

// Acción para crear un préstamo
export const crearPrestamo = (prestamoData) => async (dispatch) => {
  try {
    const response = await axiosapi.post("/api/prestamos", prestamoData);

    dispatch({
      type: CREAR_PRESTAMO_EXITOSO,
      payload: response.data.prestamo,
    });
  } catch (error) {
    console.error("Error al crear préstamo:", error);
    dispatch({
      type: CREAR_PRESTAMO_ERROR,
      payload: error.response ? error.response.data : "Error desconocido",
    });
  }
};

// Acción para crear un producto
export const crearProducto = (productoData) => async (dispatch) => {
  dispatch({ type: SET_LOADING, payload: true });
  try {
    const response = await axiosapi.post("/api/crearProducto", productoData);

    const producto = response.data?.producto;
    if (producto?.id) {
      dispatch({ type: CREAR_PRODUCTO, payload: producto });
      return producto;
    } else {
      console.error("El producto creado no tiene un ID:", response.data);
      throw new Error("Error al crear el producto: respuesta incompleta");
    }
  } catch (error) {
    console.error("Error en el POST:", error);
    dispatch({
      type: SET_ERROR,
      payload: error.response?.data?.mensaje || "Error al crear el producto",
    });
    // Propagar para que la pantalla no muestre "creado" cuando falló
    throw error;
  } finally {
    dispatch({ type: SET_LOADING, payload: false });
  }
};

// Acción para actualizar un producto
export const actualizarProducto = (productoData) => async (dispatch) => {
  dispatch({ type: SET_LOADING, payload: true });
  try {
    const response = await axiosapi.put(`/api/actualizarProducto`, productoData);
    dispatch({ type: ACTUALIZAR_PRODUCTO, payload: response.data.producto });
  } catch (error) {
    dispatch({
      type: SET_ERROR,
      payload:
        error.response?.data?.mensaje || "Error al actualizar el producto",
    });
    // Propagar para que la pantalla no muestre "actualizado" cuando falló
    throw error;
  } finally {
    dispatch({ type: SET_LOADING, payload: false });
  }
};

// Acción para obtener categorías
export const obtenerCategorias = () => async (dispatch) => {
  try {
    const response = await axiosapi.get("/api/categorias");
    dispatch({
      type: OBTENER_CATEGORIAS_EXITO,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: OBTENER_CATEGORIAS_ERROR,
      payload: error.response?.data?.mensaje || error.message,
    });
  }
};

export const obtenerProveedores = () => async (dispatch) => {
  try {
    const response = await axiosapi.get("/api/proveedores");
    dispatch({
      type: OBTENER_PROVEEDORES_EXITO,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: OBTENER_PROVEEDORES_ERROR,
      payload: error.response?.data?.mensaje || error.message,
    });
  }
};

export const crearCategoria = (categoria) => async (dispatch) => {
  try {
    const response = await axiosapi.post("/api/crearcategorias", categoria);
    dispatch({ type: CREAR_CATEGORIA_EXITO, payload: response.data });
    return response.data;
  } catch (error) {
    dispatch({
      type: CREAR_CATEGORIA_ERROR,
      payload: error.response?.data?.mensaje || error.message,
    });
    throw error;
  }
};

// Acción para crear un nuevo proveedor
export const crearProveedor = (proveedor) => async (dispatch) => {
  try {
    const response = await axiosapi.post("/api/crearproveedores", proveedor);
    dispatch({ type: CREAR_PROVEEDOR_EXITO, payload: response.data });
  } catch (error) {
    dispatch({ type: CREAR_PROVEEDOR_ERROR, payload: error.message });
  }
};

export const crearIngreso = (ingresoData) => async (dispatch) => {
  try {
    const response = await axiosapi.post("/api/ingreso", ingresoData);
    dispatch({ type: CREAR_INGRESO_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: CREAR_INGRESO_ERROR, payload: error.message });
  }
};

// Carga el usuario de la sesion del login centralizado.
// Reemplaza al email que antes se leia de localStorage, que ya nadie escribe.
export const cargarUsuarioActual = () => async (dispatch) => {
  try {
    const response = await axiosapi.get("/api/profile");
    dispatch({
      type: OBTENER_USUARIO_EXITO,
      payload: response.data.usuario,
    });
    return response.data.usuario;
  } catch (error) {
    dispatch({
      type: OBTENER_USUARIO_ERROR,
      payload: error.response?.data?.mensaje || "No se pudo cargar el usuario",
    });
    throw error;
  }
};

export const obtenerUsuario = (email) => async (dispatch) => {
  try {
    const response = await axiosapi.get(`/api/usuario?email=${email}`);
    dispatch({
      type: OBTENER_USUARIO_EXITO,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: OBTENER_USUARIO_ERROR,
      payload: error.response?.data?.mensaje || error.message,
    });
  }
};
export const getAllUser = (email) => async (dispatch) => {
  try {
    const response = await axiosapi.get(`/api/getusuarios`);
    dispatch({
      type: OBTENER_USUARIOS_EXITO,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: OBTENER_USUARIOS_ERROR,
      payload: error.response?.data?.mensaje || error.message,
    });
  }
};

export const getClientes = () => async (dispatch) => {
  try {
    const response = await axiosapi.get(`/api/getcliente`);
    dispatch({
      type: OBTENER_CLIENTE_EXITO,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: OBTENER_CLIENTE_ERROR,
      payload: error.response?.data?.mensaje || error.message,
    });
  }
};

export const getClienteHabilitado = (dni) => async (dispatch) => {
  try {
    const response = await axiosapi.get(`/api/getclientehab`, { params: { dni } });
    const { habilitado, mensaje, clienteId } = response.data;

    dispatch({
      type: OBTENER_CLIENTE_HABILITADO_EXITO,
      payload: { habilitado, clienteId },
    });

    return { habilitado, mensaje, clienteId };
  } catch (error) {
    const errorMessage = error.response?.data?.mensaje || "Error desconocido";

    dispatch({
      type: OBTENER_CLIENTE_HABILITADO_ERROR,
      payload: errorMessage,
    });

    return { habilitado: false, mensaje: errorMessage };
  }
};

export const registrarSalida = (salidaData) => async (dispatch) => {
  try {
    dispatch({ type: REGISTRAR_SALIDA_REQUEST });

    const response = await axiosapi.post("/api/salidas", salidaData);

    dispatch({
      type: REGISTRAR_SALIDA_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: REGISTRAR_SALIDA_FAILURE,
      payload: error.response?.data?.error || "Error al registrar salida",
    });
    // Propagar para no seguir con el remito cuando la salida fallo
    throw error;
  }
};

export const postCliente = (payload) => {
  return async function (dispatch) {
    try {
      var json = await axiosapi.post(`/api/postcliente`, payload);
      return json;
    } catch (error) {}
  };
};
export const postuser = (payload) => {
  return async function (dispatch) {
    try {
      var json = await axiosapi.post(`/api/postusuario`, payload);
      return json;
    } catch (error) {}
  };
};

export const setAuthToken = (token) => ({
  type: SET_AUTH_TOKEN,
  payload: token,
});